import CardWrapper from '../../components/wrapper/card';
import MessageBoardComponent from '../../components/messageboard';
import { RootState } from '../../redux/store';
import { useSelector } from 'react-redux';
import WaterCoolerComponent from '../../components/watercooler';
import { a11yProps, CustomTabPanel } from '../deals';
import React, { useState } from 'react';
import { Tab, Tabs } from '@mui/material';

const TeamSpacePage = () => {
  const [value, setValue] = useState(0);
  const { currentUser } = useSelector((state: RootState) => state.app);

  const handleChange = (event: React.SyntheticEvent, newValue: number) => {
    setValue(newValue);
  };

  if (currentUser?.role === 'client') {
    return <CardWrapper minHeight="80vh" overflow="auto">
      <MessageBoardComponent />
    </CardWrapper>;
  }

  return (
    <CardWrapper minHeight="80vh" overflow="auto">
      <Tabs
        value={value}
        onChange={handleChange}
        aria-label="Team space tabs"
      >
        <Tab
          label="Water Cooler"
          {...a11yProps(0)}
        />
        <Tab
          label="Message Board"
          {...a11yProps(1)}
        />
      </Tabs>

      <CustomTabPanel value={value} index={0}>
        <WaterCoolerComponent />
      </CustomTabPanel>

      <CustomTabPanel value={value} index={1}>
        <MessageBoardComponent />
      </CustomTabPanel>
    </CardWrapper>
  );
};

export default TeamSpacePage;